import DesignInteractionEnum from './DesignInteractionEnum';

enum OtherEventsEnum {
	start = 'start',
	addToCart = 'add_to_cart',
	addToWishList = 'add_to_wishlist',
	initiatePlanningSession = 'initiate_planning_session',
	connectApplication = 'connect_application',
	pageview = 'pageview',
	articleAction = 'article_action',
	userFlow = 'user_flow'
}
const InsightsEventEnum = { ...OtherEventsEnum, ...DesignInteractionEnum };

export default InsightsEventEnum;
